import { useLocation } from 'react-router-dom'

/**
 * The router `state` every link into the guided Rock setup carries, so
 * "Save and exit" returns to the page the person came from
 * (`exitPathFrom`, which falls back to `/dashboards`).
 *
 * @returns {{from: string}}
 */
export function useSetupLinkState() {
  const location = useLocation()
  return { from: `${location.pathname}${location.search}` }
}

export default useSetupLinkState
